/* BrukBlask landing. Nasluchy przez delegacje na dokumencie, zawsze w obrebie jednej sekcji. */
(function () {
  if (window.__bbInit) return;
  window.__bbInit = true;

  function money(cents) {
    var hasGrosze = cents % 100 !== 0;
    return (cents / 100).toLocaleString('pl-PL', {
      minimumFractionDigits: hasGrosze ? 2 : 0,
      maximumFractionDigits: 2
    }) + ' zł';
  }

  function variantsOf(root) {
    if (root.__bbVariants) return root.__bbVariants;
    var el = root.querySelector('script[data-bb-variants]');
    root.__bbVariants = el ? JSON.parse(el.textContent) : [];
    return root.__bbVariants;
  }

  function current(root) {
    var id = Number(root.getAttribute('data-variant'));
    var list = variantsOf(root);
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  }

  function packTotal(root, qty, price) {
    var off2 = Number(root.getAttribute('data-off2') || 0);
    var off3 = Number(root.getAttribute('data-off3') || 0);
    if (qty >= 3) return price * qty - off3;
    if (qty === 2) return price * 2 - off2;
    return price;
  }

  function bumpPrice(root) {
    var b = root.querySelector('[data-bb-bump]');
    return b && b.checked ? Number(b.getAttribute('data-price') || 0) : 0;
  }

  function refresh(root) {
    var v = current(root);
    if (!v) return;
    var qty = Number(root.getAttribute('data-qty') || 1);
    root.querySelectorAll('[data-bb-pack-price]').forEach(function (el) {
      var q = Number(el.getAttribute('data-bb-pack-price'));
      el.textContent = money(packTotal(root, q, v.price));
    });
    root.querySelectorAll('[data-bb-pack-save]').forEach(function (el) {
      var q = Number(el.getAttribute('data-bb-pack-save'));
      el.textContent = money(v.price * q - packTotal(root, q, v.price));
    });
    var total = money(packTotal(root, qty, v.price) + bumpPrice(root));
    root.querySelectorAll('[data-bb-total]').forEach(function (el) { el.textContent = total; });
    var sticky = document.querySelector('[data-bb-sticky-for="' + root.id + '"] [data-bb-total]');
    if (sticky) sticky.textContent = total;
  }

  function sectionOf(el) { return el.closest('[data-bb-section]'); }

  function showImage(section, src, alt) {
    if (!section || !src) return;
    var img = section.querySelector('[data-bb-main-img]');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = src;
    if (alt) img.alt = alt;
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bb-bump]')) return;
    var root = e.target.closest('[data-bb-buy]');
    if (root) refresh(root);
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.bb-swatch');
    if (sw) {
      var root = sw.closest('[data-bb-buy]');
      if (!root) return;
      root.setAttribute('data-variant', sw.getAttribute('data-id'));
      root.querySelectorAll('.bb-swatch').forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
      var v = current(root);
      showImage(sectionOf(root), v.img, v.alt);
      root.querySelectorAll('[data-bb-color-name]').forEach(function (el) { el.textContent = v.title; });
      refresh(root);
      return;
    }

    var pack = e.target.closest('.bb-pack');
    if (pack) {
      var r = pack.closest('[data-bb-buy]');
      if (!r) return;
      r.setAttribute('data-qty', pack.getAttribute('data-qty'));
      r.querySelectorAll('.bb-pack').forEach(function (b) { b.setAttribute('aria-pressed', b === pack ? 'true' : 'false'); });
      refresh(r);
      return;
    }

    var th = e.target.closest('[data-bb-thumb]');
    if (th) {
      var sec = sectionOf(th);
      showImage(sec, th.getAttribute('data-src'), th.getAttribute('data-alt'));
      sec.querySelectorAll('[data-bb-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
      return;
    }

    var stickyBtn = e.target.closest('[data-bb-sticky-add]');
    if (stickyBtn) {
      var bar = stickyBtn.closest('[data-bb-sticky-for]');
      var target = bar && document.getElementById(bar.getAttribute('data-bb-sticky-for'));
      var main = target && target.querySelector('[data-bb-add]');
      if (main) main.click();
      return;
    }

    var add = e.target.closest('[data-bb-add]');
    if (add) {
      var buy = add.closest('[data-bb-buy]');
      if (!buy) return;
      var chosen = current(buy);
      var q = Number(buy.getAttribute('data-qty') || 1);
      var items = [{ id: chosen.id, quantity: q }];
      var bump = buy.querySelector('[data-bb-bump]:checked');
      if (bump) items.push({ id: Number(bump.value), quantity: 1 });
      var err = buy.querySelector('[data-bb-error]');
      if (err) err.textContent = '';
      var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      add.setAttribute('disabled', 'disabled');
      fetch(root2 + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('add');
        window.location.href = root2 + 'cart';
      }).catch(function () {
        add.removeAttribute('disabled');
        if (err) err.textContent = 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
      });
      return;
    }

    var up = e.target.closest('[data-bb-cartup-add]');
    if (up) {
      up.setAttribute('disabled', 'disabled');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(up.getAttribute('data-bb-cartup-add')), quantity: 1 }] })
      }).then(function () { window.location.reload(); })
        .catch(function () { up.removeAttribute('disabled'); });
    }
  });

  function initAll() {
    document.querySelectorAll('[data-bb-buy]').forEach(function (root) {
      if (root.__bbReady) return;
      root.__bbReady = true;
      refresh(root);
      var bar = document.querySelector('[data-bb-sticky-for="' + root.id + '"]');
      var btn = root.querySelector('[data-bb-add]');
      if (bar && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var past = !en.isIntersecting && en.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', past);
          });
        }).observe(btn);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();